// Partners page: strategic shipping carriers + industry partners (confirmed) and
// an "in discussion" row, rendered as brand-colored wordmarks via PartnerStrip.
// Partner names from company-profile/content.md; the profile flags 德迅/中国外运
// as under discussion (kept in a separate labeled row). Owned by Agent D.
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { DEFAULT_LOCALE } from "../i18n";
import PageHero from "../components/PageHero";
import SectionBlock from "../components/SectionBlock";
import PageMeta from "../components/PageMeta";
import PartnerStrip, {
  CARRIERS,
  INDUSTRY,
  IN_DISCUSSION,
} from "../components/PartnerStrip";

export default function Partners() {
  const { t } = useTranslation("partners");
  const { lang } = useParams();
  const current = lang ?? DEFAULT_LOCALE;

  return (
    <div className="page page-partners">
      <PageMeta title={t("meta.title")} description={t("meta.description")} lang={current} />

      <PageHero
        eyebrowEn={t("hero.eyebrowEn")}
        title={t("hero.title")}
        subtitle={t("hero.subtitle")}
      />

      {/* Confirmed shipping carriers */}
      <SectionBlock
        eyebrowEn={t("carriers.eyebrowEn")}
        heading={t("carriers.title")}
        lead={t("carriers.lead")}
      >
        <PartnerStrip partners={CARRIERS} lang={current} columns={4} />
      </SectionBlock>

      {/* Industry partners */}
      <SectionBlock
        eyebrowEn={t("industry.eyebrowEn")}
        heading={t("industry.title")}
        lead={t("industry.lead")}
        surface="tint"
      >
        <PartnerStrip partners={INDUSTRY} lang={current} columns={2} />
      </SectionBlock>

      {/* In discussion */}
      <SectionBlock
        eyebrowEn={t("discussion.eyebrowEn")}
        heading={t("discussion.title")}
        lead={t("discussion.lead")}
      >
        <PartnerStrip partners={IN_DISCUSSION} lang={current} columns={2} muted />
        <p className="mt-8 max-w-3xl text-[var(--text-sm)] leading-[var(--leading-body)] text-[var(--brand-slate-text)]">
          {t("note")}
        </p>
      </SectionBlock>
    </div>
  );
}
